import { contains } from 'jquery';
import axios from './axios'

export async function fhirOperations(type: string, name:string) {
    const response = await axios.get("/api/getFhirData");
    if(type == "download") {
        downloadJson(response.data, name);
    } else {
        const url = window.URL.createObjectURL(new Blob([JSON.stringify(response.data, null, 4)]));
        window.open(url, '_blank');
    }
}

function downloadJson(json, name: string) {
    const url = window.URL.createObjectURL(new Blob([JSON.stringify(json, null, 4)]));
    const link = document.createElement('a');
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    const tdate = mm + '-' + dd + '-' + yyyy;
    link.href = url;
    link.setAttribute('download', 'Fhir_' + name + '_' + tdate + '.txt');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}